
export const TechnicalEngagementLinkUtil = (environmentData) => {
    if(!environmentData){
        return '';
    }

    const {technicalEngagementId} = environmentData;

    return process.env.REACT_APP_TECHNICAL_ENGAGEMENT_URL + technicalEngagementId + "/view"

}
